<div class="p-field-content-container" [ngClass]="customClasses">
    <span *ngIf="showLeftLabel()" class="p-field-label-text p-field-label" [class.disabled]="isDisable">
        <p-icon class="tooltip-icon" *ngIf="preLabelIcon" [name]="preLabelIcon" [color]="preLabelIconColor"></p-icon>
        <span *ngIf="isMandatory" class="p-field-mandatory p-field-mandatory-alert">*</span>
        {{ shouldTransformLabelTextCase ? (label | sentenceCase) : label }}
        <p-icon class="tooltip-icon" *ngIf="labelTooltip" [matTooltip]="labelTooltip" name="info"></p-icon>
        <a
            class="action-icon"
            *ngIf="actionIconName"
            href="{{ actionIconUrl }}"
            target="_blank"
            [matTooltip]="actionIconTooltip || ''"
            (click)="onActionIconClick($event)"
        >
            <p-icon [name]="actionIconName" class="tooltip-icon"></p-icon>
        </a>
    </span>

    <div class="p-field p-field-content-container" [class.is-readonly]="isReadOnly">
        <ng-content *ngIf="!isEditable" select="[slot=readMode]"></ng-content>
        <ng-content *ngIf="isEditable" select="[slot=editMode]"></ng-content>
    </div>
    <span
        *ngIf="showRightLabel()"
        [attr.automation-id]="label | toAutomationId: { suffix: '-label' }"
        [matTooltip]="labelTooltip ?? ''"
        class="p-field-label-text p-field-label p-field-label__right"
    >
        {{ label }}
    </span>
</div>
